import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_AGENT,
    GET_ALL_AGENTS,
    GET_AGENT_REQUEST,
    CREATE_AGENT,
    UPDATE_AGENT,
    DELETE_AGENT,
    CLEAR_AGENT,
    AGENT_ERROR,
    AGENT_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all agents
export const getAgents = () => async dispatch => {
    try {
        dispatch({ type: AGENT_LOADING });
        
        const res = await axios.get(`${API_URL}/agents`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_AGENTS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: AGENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get agent by ID
export const getAgent = (id) => async dispatch => {
    try {
        dispatch({ type: GET_AGENT_REQUEST });
        
        const res = await axios.get(`${API_URL}/agents/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_AGENT,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: AGENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create agent
export const createAgent = (formData) => async dispatch => {
    try {
        dispatch({ type: AGENT_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.post(`${API_URL}/agents`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_AGENT,
                payload: res.data.data
            });
            dispatch(setAlert('Agent created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        
        }
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create agent', 'danger'));
        }
        
        dispatch({
            type: AGENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Update agent
export const updateAgent = (id, formData) => async dispatch => {
    try {
        dispatch({ type: AGENT_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.put(`${API_URL}/agents/${id}`, formData, config);
        
        dispatch({
            type: UPDATE_AGENT,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Agent updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        
        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update agent', 'danger'));
        }
        
        dispatch({
            type: AGENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Delete agent
export const deleteAgent = (id) => async dispatch => {
    try {
        dispatch({ type: AGENT_LOADING });
        
        const res = await axios.delete(`${API_URL}/agents/${id}`);
        
        dispatch({
            type: DELETE_AGENT,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Agent deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: AGENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        dispatch(setAlert('Failed to delete agent', 'danger'));
    }
};

// Clear agent
export const clearAgent = () => dispatch => {
    dispatch({ type: CLEAR_AGENT });
};

// Upload agent document
export const uploadAgentDocument = (payload) => async dispatch => {
    try {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        const data = new FormData();
        data.append('document', payload.file); // Changed 'file' to 'document' to match server expectation
        
        const res = await axios.put(`${API_URL}/agents/${payload.agent_id}/documents/${payload.documentType}`, data, config);
        
        if(res.data.success){
            dispatch(setAlert('Document uploaded successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        return res.data;
    } catch (err) {
        dispatch(setAlert('Failed to upload document', 'danger'));
        throw err;
    }
};
